module.exports = __webpack_public_path__ + "img/entrance_full.51413897.jpg";